var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXSecondary = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "#ffffff",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.417.508.825.825L8.574 8l6.668 6.667-.825.825-7.08-7.08a.583.583 0 0 1-.061-.752l.062-.072 7.079-7.08z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.325 15.492.5 14.667 7.167 8 .5 1.333l.825-.825 7.08 7.08a.583.583 0 0 1 .06.752l-.06.072-7.08 7.08z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgXSecondary);
export default ForwardRef;